import { useEffect, useState } from "react";
import { toggleFavVideoApiCall } from "@/services/api"
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from "@/store";
import { toggleVideoFavouriteById } from '@/store/slices/video/seriesSlice';
import ShareModal from '@/components/video/videoShareModal/videoShareModal'

import SeriesListMainView from "./view";

import "./style.css"
import { useAuthToken } from "@/hooks/useAppSelectors";
import { addCurrentThemeClassToEle, hasQueryParam, scrollToAVideoInSeriesList } from "@/utils";
import { allQueryParam } from "@/constants/urlPaths";
import { useSearchParams } from "react-router-dom";
import { useSafeAreaInsets } from "@/hooks/useSafeAreaInsets";

export default function SeriesListMain(props: any) {
    const dispatch = useDispatch();
    const token = useAuthToken();
    const [searchParams] = useSearchParams();
    const isSubscribedSeries = searchParams.get("subscription") === "true";
    const { topSafeComponent, bottomSafeComponent } = useSafeAreaInsets();
    const [showShareUrlModal, setShowShareUrlModal] = useState(false);
    const [urlToShare, setUrlToShare] = useState("")

    const videoDetails = useSelector((state: RootState) => state.videoReducer.video);

    const [openIndices, setOpenIndices] = useState<number[]>([]);
    const [whichFavBtnIsLoading, setWhichFavBtnIsLoading] = useState("")

    const [seriesId, setSeriesId] = useState(searchParams.get("series"));
    const [videoId, setVideoId] = useState(searchParams.get("video"));

    const [targetVideoIdToScroll, setTargetVideoIdToScroll] = useState<string | null>(null);

    const currentTheme = useSelector((state: RootState) => state.currentThemeReducer.currentTheme);

    // useEffect(() => {
    //     console.log("openIndex ", openIndex)
    // }, [openIndex])

    // useEffect(()=>{
    //     console.log(props.currentVideoObj)
    // },[props.currentVideoObj])


    useEffect(() => {
        return () => {
            window.scrollTo(0, 0);
        };
    }, []);


    useEffect(() => {
        if (props.seriesDetails && props.seriesDetails.length > 0
            && props.currentVideoObj && Object.entries(props.currentVideoObj).length > 0) {
            const videoDocId = props.currentVideoObj._id;
            const currentSeriesIndexWhereCurrentVideoIs = findSectionIndexByVideoId(props.seriesDetails, videoDocId);
            
            // Only open the accordion if it's not already open and if we found a valid index
            if (currentSeriesIndexWhereCurrentVideoIs !== -1) {
                setOpenIndices([currentSeriesIndexWhereCurrentVideoIs]);
            }
        }
    }, [props.seriesDetails, props.currentVideoObj]);



    const toggleAccordion = (index: number) => {
        setOpenIndices(prevIndices => {
            if (prevIndices.includes(index)) {
                // If clicking on an open accordion, close it
                return prevIndices.filter(i => i !== index);
            } else {
                // If clicking on a closed accordion, open it (keep existing open ones open)
                return [...prevIndices, index];
            }
        });
    };


    // START : Logic to close the accordion when bottomSeriesIsOpen isclosed
    useEffect(() => {
        if (props.bottomSeriesIsOpen) {
            scrollToVideo('bottom')
        }

        if (props.hasOwnProperty('bottomSeriesIsOpen')
            && props.bottomSeriesIsOpen === false) {
            toggleAccordion(-1)
        }
    }, [props.bottomSeriesIsOpen])
    // END : Logic to close the accordion when bottomSeriesIsOpen isclosed



    // START -------- Code to video scroll
    useEffect(() => {
        // Fix: Use openIndices.length > 0 instead of openIndex !== null
        if (targetVideoIdToScroll && openIndices.length > 0) {
            const divId = `seriesContentCon_videoId_${targetVideoIdToScroll}`;
            const el = document.getElementById(divId);

            if (el) {
                scrollToAVideoInSeriesList(divId);
                setTargetVideoIdToScroll(null);
            }
        }
    }, [openIndices, targetVideoIdToScroll]);



    const scrollToVideo = (source: any) => {
        if (props.seriesDetails
            && props.seriesDetails.length > 0
            && props.currentVideoObj
            && Object.entries(props.currentVideoObj).length > 0) {
            const videoDocId = props.currentVideoObj._id
            const currentSeriesIndexWhereCurrentVideoIs = findSectionIndexByVideoId(props.seriesDetails, videoDocId)
            
            // Open the accordion for the current video and keep existing open ones
            setOpenIndices(prevIndices => {
                if (!prevIndices.includes(currentSeriesIndexWhereCurrentVideoIs)) {
                    return [...prevIndices, currentSeriesIndexWhereCurrentVideoIs];
                }
                return prevIndices;
            });
            
            setTargetVideoIdToScroll(videoDocId);
        }
    }

    const findSectionIndexByVideoId = (sections: any, videoId: any) => {
        return sections.findIndex((section: { videos: any[]; }) =>
            section.videos?.some(video => video._id === videoId)
        );
    }
    // END -------- Code to video scroll


    const handleVideoFavBtnClick = async (videoDocId: string, seriesId: string) => {
        setWhichFavBtnIsLoading(videoDocId)
        const payload = {
            videoDocId: videoDocId,
            isWelcomeSeries: props.isWelcomeSeries,
            isWelcomeOfferVideo: Boolean(props.isWelcomeSeries),
            isSubscribedVideo: isSubscribedSeries,
            seriesId: seriesId,
        }
        const toggleFavVideoApiCallStatus = await toggleFavVideoApiCall(payload)
        if (toggleFavVideoApiCallStatus.status) {
            dispatch(toggleVideoFavouriteById(payload));
        } else {
            console.log(`Issue in handleVideoFavBtnClick : serieIndex : videoDocId : ${videoDocId} `)
        }
        setWhichFavBtnIsLoading("")
    }

    const changeVideo = (videoDocId: string) => {
        // console.log("changeVideo : ", videoDocId)
        // debugger
        props.updateCurrentVideoObj(videoDocId)
    }


    const handleShare = () => {
        const currentUrl = window.location.href;
        setUrlToShare(currentUrl)
        handleOpenShareUrlModal()
    }
    const handleOpenShareUrlModal = () => {
        setShowShareUrlModal(true)
    };
    const handleCloseShareUrlModal = (status: string) => {
        setShowShareUrlModal(false)
    }


    return (
        <div
            id="seriesListMain"
            className={`seriesListMain 
            ${(props.bottomSeriesIsOpen
                    && openIndices.length > 0) ? "bottomSeriesViewMain_bottomExtraPadding" : ""}
            ${addCurrentThemeClassToEle(currentTheme, 'seriesListMain')}
            `}
        >
            {props.bottomSeriesIsOpen ? null : topSafeComponent}
            {props.isLoading ? (
            // {true ? ( // testing
                <div className="animate-pulse seriesListMainLoader">
                    <div className="space-y-6">
                        {[1, 2, 3, 4, 5, 6, 7, 8].map(module => (
                            <div key={module} className="h-10 w-full seriesListMainLoader_gray_300 rounded" />
                        ))}
                    </div>
                </div>
            ) : (
                <>
                    {/* {!isPublicVideo(props.currentVideoObj) && props.currentVideoObj && */}
                    {hasQueryParam(allQueryParam.series)
                        && token && props.currentVideoObj &&
                        <>
                            {props.seriesDetails && props.seriesDetails.map((serie: any, index: number) => (
                                <div
                                    key={index}
                                >
                                    <SeriesListMainView
                                        serieIndex={index}
                                        serie={serie}
                                        isOpen={openIndices.includes(index)}
                                        onToggle={() => toggleAccordion(index)}
                                        handleVideoFavBtnClick={handleVideoFavBtnClick}
                                        whichFavBtnIsLoading={whichFavBtnIsLoading}
                                        changeVideo={changeVideo}
                                        videoDetails={videoDetails}
                                        handleShare={handleShare}
                                        videoChangingId={props.videoChangingId}
                                        currentVideoId={(props.currentVideoObj && props.currentVideoObj._id)
                                            ? props.currentVideoObj._id : null}
                                    />
                                    {index < props.seriesDetails.length - 1 &&
                                        <hr className="text-[#a1a0a0] mb-[15px] mt-[15px]" />
                                    }
                                </div>
                            ))}
                            {bottomSafeComponent}
                        </>
                    }
                </>
            )}

            <ShareModal
                show={showShareUrlModal}
                handleClose={handleCloseShareUrlModal}
                urlToShare={urlToShare}
            />

        </div>
    );
}
